import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import chTranslations from './locales/ch/translation.json';
import enTranslations from './locales/en/translation.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        // the translations
        // (tip move them in a JSON file and import them,
        // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
        resources: {
            en: {
                translation: enTranslations
            },
            ch: {
                translation: chTranslations
            },
            zh: {
                translation: chTranslations
            },
            'zh-CN': {
                translation: chTranslations
            },
            'zh-TW': {
                translation: chTranslations
            }
        },
        fallbackLng: 'en',
        
        detection: {
            order: ['navigator'],
            caches: []
        },

        interpolation: {
            escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
        }
    });

export default i18n;
